export const extractUserIdFromPaymentUrl = (url: string): string | null => {
  try {
    const urlObj = new URL(url);
    const uid = urlObj.searchParams.get('uid');
    return uid;
  } catch (error) {
    console.error('Error extracting user ID from URL:', error);
    return null;
  }
}; 